import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import {Button, ButtonAttrs, ButtonJsxProps} from '../button';
import {template} from './template';
import {AsyncButtonState} from './types';

export class AsyncButton extends Component<AsyncButtonState, ButtonAttrs> {
  static get attrsSchema(): AttrsSchema<ButtonAttrs> {
    return {...Button.attrsSchema};
  }

  get config() {
    return Object.assign(super.config, {
      template,
      useShadowDom: true,
      defaultState: {
        isWaiting: false,
      },
      helpers: {
        ...super.config.helpers,
        getButtonAttrs: () => ({
          ...this.attrs(),
          ...(this.attr(`elref`) ? {elref: `${this.attr(`elref`)}Inner`} : {}),
          icon: this.state.isWaiting ? `spinner` : this.attr(`icon`),
          disabled: this.helpers.isDisabled(),
        }),
        handleButtonClick: () => this._asyncAction && this._asyncAction(),
        isDisabled: () => this.attr(`disabled`) || this.state.isWaiting,
      },
    });
  }

  private _asyncAction = null;

  updatePointerEvents() {
    // We want to disable the outer mp-async-button click events when the inner mp-button is disabled
    this.style.pointerEvents = this.helpers.isDisabled() ? `none` : ``;
  }

  setIsWaiting(isWaiting) {
    this.update({isWaiting});
    this.updatePointerEvents();
  }

  set asyncAction(action) {
    this._asyncAction = async () => {
      this.setIsWaiting(true);
      try {
        await action();
      } finally {
        this.setIsWaiting(false);
      }
    };
  }

  attributeChangedCallback(attr, oldValue, newValue) {
    super.attributeChangedCallback(attr, oldValue, newValue);
    if (attr === `disabled`) {
      this.updatePointerEvents();
    }
  }
}

export const AsyncButtonEl = defineAndMakeJsxFactory<ButtonJsxProps>(`mp-async-button`, AsyncButton);
